<template>
    <v-card
        class="elevation-0 ml-lg-n2 mb-4"
        width="89vw"
        :max-width="$vuetify.breakpoint.mdAndUp ? '450px' : '100%'"
    >
        <v-card-text class="pa-6 pt-0" id="scroller">
            <v-sheet
                tile
                color="#f9f9f9"
                class="px-5 rounded-lg pt-4"
            >
                <v-row>
                    <v-col class="pb-0">
                        <p class="my-0">You send</p>
                        <p class="body-1 my-0 font-weight-bold mb-0">
                            {{ getCurrencySymbol(this.selectedOrder.matcher_currency) }}{{ youSend }}
                        </p>
                    </v-col>
                    <v-col cols="2" class="pb-0 pr-0">
                        <p class="title my-0 mt-2 primary--text">To</p>
                    </v-col>
                    <v-col class="text-right">
                        <p class="my-0">The Recipient</p>
                        <p class="body-1 font-weight-bold mb-0">{{ recipient.name }}</p>
                    </v-col>
                </v-row>
            </v-sheet>

            <div
                class="px-1 pt-10"
                :class="[{ 'pt-16 mt-8': selectedOrder.type === '3po' }]"
            >
                <v-row v-if="selectedOrder.matcher_payment_method_fee">
                    <v-col class="py-0">
                        <p class="my-0 subtitle-1 text-capitalize">{{ selectedOrder.matcher_payment_provider }} Fee</p>
                    </v-col>
                    <v-col class="text-right py-0">
                        <p class="body-1 subtitle-1 my-0 font-weight-bold">
                            {{ providerFee }}
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0 d-flex">
                        <p class="my-0 subtitle-1">Kaoshi Fee</p>
                        <v-tooltip right v-if="coupon.description">
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    v-on="on"
                                    class="ml-1 dense"
                                    size="16"
                                    color="teal accent-4"
                                >
                                    mdi-information-outline
                                </v-icon>
                            </template>
                            <span>
                                {{ coupon.description }}
                            </span>
                        </v-tooltip>
                    </v-col>
                    <v-col class="text-right py-0">
                        <p class="body-1 my-0 font-weight-bold">
                            {{ getCurrencySymbol(selectedOrder.matcher_currency) }}{{ feeInMatcherCurrency.toFixed(2) }}
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <v-divider class="ml-0" inset></v-divider>
                    </v-col>
                    <v-col class="py-0">
                        <p class="my-0 subtitle-1 font-weight-bold">SubTotal</p>
                    </v-col>
                    <v-col class="text-right py-0">
                        <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                            {{ getCurrencySymbol(this.selectedOrder.matcher_currency) }}{{ subtotal }}
                            <span
                                v-if="selectedOrder.type === 'hybrid'"
                                class="caption"
                            >
                                {{ getCurrencySymbol(this.selectedOrder.matcher_currency) }}{{ youSend }}
                            </span>
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="py-0">
                        <p class="my-0 subtitle-1 font-weight-bold">
                            Exchange Rate
                        </p>
                    </v-col>
                    <v-col class="text-right py-0" v-if="exchangeRate > 1">
                        <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                            {{ (exchangeRate).toFixed(3) }}
                            {{ selectedOrder.poster_currency }} / {{ selectedOrder.matcher_currency }}
                        </p>
                    </v-col>
                    <v-col class="text-right py-0" v-else>
                        <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                            {{ (1 / exchangeRate).toFixed(3) }}
                            {{ selectedOrder.matcher_currency }} / {{ selectedOrder.poster_currency }}
                        </p>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="pt-0">
                        <p class="my-0 subtitle-1 font-weight-bold">
                            Recipient receives
                        </p>
                    </v-col>
                    <v-col class="text-right py-0">
                        <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                            {{ recipientGets }} {{ selectedOrder.poster_currency }}
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="ml-1 dense"
                                        color="teal accent-4"
                                        size="16"
                                    >
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>
                                    {{ amountInfo }}
                                </span>
                            </v-tooltip>
                        </p>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>

        <template v-if="selectedOrder.type !== '3po'">
             <v-alert v-if="selectedOrder.fake" color="warning" class="body-2 mb-0 pa-6" text dense>
                Clicking the accept button will redirect you to {{ selectedOrder.company.name }}'s
                website to complete your transfer.
            </v-alert>
            <v-alert v-else color="warning" class="body-2 mb-0 pa-6" text dense>
                By accepting this offer, you commit to this transaction.
                Failure to make payment within 2 hours of accepting this offer could result in a restriction/suspension of your account.
            </v-alert>
        </template>

        <v-card-actions
            class="px-6 mt-4"
            :class="[{ 'px-10 mt-8': selectedOrder.type === '3po' }]"
        >
            <v-btn
                class="text-capitalize px-6 cancel"
                text
                color="red darken-2"
                large
                @click="$emit('cancel')"
            >
                Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                class="text-capitalize px-10 rounded-lg"
                color="primary"
                dark
                depressed
                large
                @click="$emit('accept')"
            >
                Accept
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
let currency = require('../../../modules/currency.js');

export default {
    name: 'confirm-transfer',
    data: data,
    props: {
        fee: Number,
        selectedOrder: Object,
        recipient: Object,
        userRecipient: Object,
        paymentType: String,
        couponProp: Object,
    },
    methods: getMethods(),
    computed: getComputed()
};

function data() {
    return {
        coupon: this.couponProp,
    }
}

function getComputed() {
    return {
        youSend,
        youSendInPbCurrency,
        show,
        exchangeRate,
        amountInfo,
        feeAmount,
        subtotal,
        subtotalInPbCurrency,
        recipientGets,
        providerFee() {
            const symbol = this.getCurrencySymbol(this.selectedOrder.matcher_currency);
            const amount = parseFloat(this.selectedOrder.matcher_payment_method_fee).toFixed(2);

            return `${symbol}${amount}`;
        },
        feeInMatcherCurrency() {
            const {
                pb_to_matcher_exchange_rate: pbToMatcherExchangeRate,
            } = this.selectedOrder;

            return this.feeAmount / (pbToMatcherExchangeRate || 1)
        }
    };

    function youSend() {
        const {
            type,
            matcher_amount: matcherAmount,
            matcher_payment_method_fee: matcherPaymentPethodFee,
            pb_to_matcher_exchange_rate: pbToMatcherExchangeRate,
        } = this.selectedOrder;
        const kaoshiFee = this.feeAmount;
        let totalAmount = 0;

        if (type === 'hybrid') {
            totalAmount = parseFloat(matcherAmount)
                + parseFloat(kaoshiFee/pbToMatcherExchangeRate)
                + parseFloat(matcherPaymentPethodFee);
        } else {
            totalAmount = parseFloat(kaoshiFee) + parseFloat(matcherAmount);
        }

        return this.formatAmount(totalAmount);
    }

    function youSendInPbCurrency() {
        const {
            type,
            pb_amount: pbAmount,
            matcher_payment_method_fee: matcherPaymentPethodFee,
            pb_to_matcher_exchange_rate: pbToMatcherExchangeRate,
        } = this.selectedOrder;
        let totalAmount = 0;

        if (type === 'hybrid') {
            totalAmount = parseFloat(pbAmount)
                + parseFloat(this.feeAmount)
                + parseFloat(matcherPaymentPethodFee * pbToMatcherExchangeRate);
                return this.formatAmount(totalAmount);
        }

        return null;
    }

    function show() {
        return {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    }

    function exchangeRate() {
        const vm = this;
        if(vm.selectedOrder.type === '3po') {
            return vm.selectedOrder.exchange_rate;
        } else {
            return vm.selectedOrder.poster_amount / vm.selectedOrder.matcher_amount;
        }
    }

    function amountInfo(){
        const vm = this;
        const posterSymbol = vm.getCurrencySymbol(vm.selectedOrder.poster_currency);
        const matcherSymbol = vm.getCurrencySymbol(vm.selectedOrder.matcher_currency);
        const amount = vm.currencyFormat(matcherSymbol, vm.selectedOrder.matcher_amount);
        const rate = vm.formatAmount(vm.selectedOrder.exchange_rate);
        if (vm.selectedOrder.fakeFee !== null && vm.selectedOrder.fakeFee !== undefined) {
            const fee = vm.currencyFormat(matcherSymbol, vm.selectedOrder.fakeFee);
            return `(${amount} sent - ${fee} fee) x ${rate} exchange rate`;
        } else {
            const fee = vm.currencyFormat(matcherSymbol, vm.fee);
            const discount = vm.coupon ? vm.currencyFormat(matcherSymbol, vm.coupon.discount) : 0;
            return `(${amount} sent - ${fee} fee + ${discount} discount) x ${rate} exchange rate`;
        }
    }

    function feeAmount() {
        const vm = this;
        if (vm.selectedOrder.fakeFee !== null && vm.selectedOrder.fakeFee !== undefined) {
            return parseFloat(vm.selectedOrder.fakeFee);
        } else {
            return parseFloat(vm.fee);
        }
    }

    function subtotal() {
        if (this.selectedOrder.type === 'hybrid') {
            const {
                matcher_amount: matcherAmount,
                pb_to_matcher_exchange_rate: pbToMatcherExchangeRate,
            } = this.selectedOrder;

            return this.formatAmount(matcherAmount + this.feeAmount / pbToMatcherExchangeRate);
        }

        return this.formatAmount(this.selectedOrder.matcher_amount);
    }

    function subtotalInPbCurrency() {
        if (this.selectedOrder.type === 'hybrid') {
            const totalAmount = parseFloat(this.selectedOrder.pb_amount) + parseFloat(this.feeAmount);
            return this.formatAmount(totalAmount);
        }

        return null;
    }

    function recipientGets() {
        return this.formatAmount(this.selectedOrder.poster_amount);
    }

    function matcherSymbol() {
        const vm = this;
        return getCurrencySymbol(vm.selectedOrder.matcher_currency);
    }
}

function getMethods() {
    return {
        getCurrencySymbol,
        currencyFormat
    };

    function currencyFormat(symbol, num) {
        num = num ? num : 0;
        return symbol + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    function getCurrencySymbol(currency_code) {
        return currency.getCurrencySymbol(currency_code);
    }
}
</script>

<style scoped>
.w-400 {
    width: 400px;
}

.cancel {
    background-color: #FFEDD3;
}

.theme--light.v-divider {
    border-color: #D2D2D2;
    max-width: 100%;
}
</style>
